// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-826e63e4!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 1160
// module chunks = 129